var _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBeachAccess(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_16811_23685",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 14,
    height: 14
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_16811_23685)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.4333 12.2501L7.72917 8.54589L8.54583 7.72922L12.25 11.4334L11.4333 12.2501ZM3.47083 11.8417C2.8875 11.2584 2.45486 10.6021 2.17292 9.87297C1.89097 9.14381 1.75 8.40006 1.75 7.64172C1.75 6.88339 1.89097 6.1445 2.17292 5.42506C2.45486 4.70561 2.8875 4.05422 3.47083 3.47089C4.05417 2.88756 4.70799 2.45249 5.43229 2.16568C6.1566 1.87888 6.89792 1.73547 7.65625 1.73547C8.41458 1.73547 9.1559 1.87888 9.88021 2.16568C10.6045 2.45249 11.2583 2.88756 11.8417 3.47089L3.47083 11.8417ZM3.5875 10.0626L4.375 9.27506C4.21944 9.07089 4.07118 8.86186 3.93021 8.64797C3.78924 8.43409 3.66042 8.2202 3.54375 8.00631C3.42708 7.79242 3.325 7.57853 3.2375 7.36464C3.15 7.15075 3.07222 6.94172 3.00417 6.73756C2.89722 7.31117 2.88993 7.88478 2.98229 8.45839C3.07465 9.032 3.27639 9.56672 3.5875 10.0626ZM5.22083 8.45839L8.45833 5.19172C8.04028 4.87089 7.61979 4.61082 7.19688 4.41152C6.77396 4.21221 6.37778 4.0761 6.00833 4.00318C5.63889 3.93027 5.3059 3.91811 5.00937 3.96672C4.71285 4.01533 4.48194 4.12228 4.31667 4.28756C4.15139 4.46256 4.04444 4.69832 3.99583 4.99485C3.94722 5.29138 3.95937 5.62679 4.03229 6.0011C4.10521 6.3754 4.24132 6.77159 4.44062 7.18964C4.63993 7.6077 4.9 8.03061 5.22083 8.45839ZM9.275 4.37506L10.0917 3.58756C9.57639 3.27645 9.03194 3.07228 8.45833 2.97506C7.88472 2.87783 7.31111 2.88756 6.7375 3.00422C6.95139 3.07228 7.16528 3.15006 7.37917 3.23756C7.59306 3.32506 7.80694 3.42471 8.02083 3.53652C8.23472 3.64832 8.44618 3.77471 8.65521 3.91568C8.86424 4.05665 9.07083 4.20978 9.275 4.37506Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBeachAccess);
export default __webpack_public_path__ + "static/media/beach_access.8b975dd76e3df469cf6e6dc963c2fa0c.svg";
export { ForwardRef as ReactComponent };